export function createVariableToken(id: string) {
	return `{var.${id}}`;
}
